(function () {
  function initJMCompatNav() {
    var index = window.JM_COMPAT_INDEX || {};

    var brandSelect = document.getElementById('jm-brand-select');
    var seriesSelect = document.getElementById('jm-series-select');
    var modelSelect = document.getElementById('jm-model-select');
    var viewBtn = document.getElementById('jm-view-collection-btn');

    if (!brandSelect || !seriesSelect || !modelSelect || !viewBtn) {
      return;
    }

    function escapeHtml(value) {
      return String(value == null ? '' : value)
        .replace(/&/g, '&amp;')
        .replace(/"/g, '&quot;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');
    }

    function firstPresent(source, keys) {
      if (!source || typeof source !== 'object') return '';
      for (var i = 0; i < keys.length; i += 1) {
        var value = source[keys[i]];
        if (value !== undefined && value !== null && String(value).trim() !== '') {
          return String(value).trim();
        }
      }
      return '';
    }

    function normalizeCollectionUrl(rawValue) {
      var value = String(rawValue || '').trim();
      if (!value) return '';

      if (value.indexOf('/') === 0) {
        return value;
      }

      if (/^https?:\/\//i.test(value)) {
        try {
          var url = new URL(value, window.location.origin);
          if (url.origin === window.location.origin) {
            return url.pathname + url.search + url.hash;
          }

          // Full URLs coming directly from the compatibility index are treated as trusted index data.
          return value;
        } catch (e) {
          return '';
        }
      }

      return '/collections/' + value.replace(/^collections\//, '').replace(/^\/+/, '');
    }

    function normalizeModelEntry(entry) {
      if (!entry || typeof entry !== 'object') return null;

      var label = firstPresent(entry, [
        'model_name',
        'model_display_name',
        'model',
        'title',
        'name'
      ]);

      var directUrl = firstPresent(entry, ['url']);
      var handle = firstPresent(entry, [
        'collection_handle',
        'handle',
        'collection',
        'collectionHandle'
      ]);
      var target = normalizeCollectionUrl(directUrl || handle);

      if (!label || !target) return null;

      return {
        label: label,
        target: target
      };
    }

    function getBrandKeys() {
      try {
        return Object.keys(index || {}).filter(Boolean).sort();
      } catch (e) {
        return [];
      }
    }

    function populateBrandDropdown() {
      var brandKeys = getBrandKeys();

      if (!brandKeys.length) {
        brandSelect.innerHTML = '<option value="">Select a brand…</option>';
        return;
      }

      var options = ['<option value="">Select a brand…</option>'];
      brandKeys.forEach(function (brand) {
        options.push('<option value="' + escapeHtml(brand) + '">' + escapeHtml(brand) + '</option>');
      });

      brandSelect.innerHTML = options.join('');
    }

    function resetSeriesAndModels() {
      seriesSelect.innerHTML = '<option value="">Select a brand first…</option>';
      seriesSelect.disabled = true;
      resetModels();
    }

    function resetModels() {
      modelSelect.innerHTML = '<option value="">Select a series first…</option>';
      modelSelect.disabled = true;
      viewBtn.disabled = true;
      viewBtn.removeAttribute('data-collection-url');
      viewBtn.removeAttribute('data-collection-handle');
      viewBtn.setAttribute('data-disabled-reason', 'Select a brand, series & model first.');
    }

    populateBrandDropdown();
    resetSeriesAndModels();

    brandSelect.addEventListener('change', function () {
      var brand = brandSelect.value;
      resetModels();

      if (!brand) {
        resetSeriesAndModels();
        return;
      }

      var brandData = index[brand];
      if (!brandData || typeof brandData !== 'object') {
        seriesSelect.innerHTML = '<option value="">No series found yet for this brand…</option>';
        seriesSelect.disabled = true;
        return;
      }

      var seriesKeys = Object.keys(brandData).filter(Boolean).sort();
      if (!seriesKeys.length) {
        seriesSelect.innerHTML = '<option value="">No series found yet for this brand…</option>';
        seriesSelect.disabled = true;
        return;
      }

      var seriesOptions = ['<option value="">Select a series…</option>'];
      seriesKeys.forEach(function (seriesName) {
        seriesOptions.push('<option value="' + escapeHtml(seriesName) + '">' + escapeHtml(seriesName) + '</option>');
      });

      seriesSelect.innerHTML = seriesOptions.join('');
      seriesSelect.disabled = false;
      viewBtn.disabled = true;
      viewBtn.setAttribute('data-disabled-reason', 'Select a series and model for this brand.');
    });

    seriesSelect.addEventListener('change', function () {
      var brand = brandSelect.value;
      var series = seriesSelect.value;
      resetModels();

      if (!brand || !series) return;

      var models = index[brand] && index[brand][series];
      if (!Array.isArray(models) || !models.length) {
        modelSelect.innerHTML = '<option value="">No models found yet for this series…</option>';
        modelSelect.disabled = true;
        return;
      }

      var modelOptions = ['<option value="">Select your exact model…</option>'];
      models.forEach(function (entry) {
        var normalized = normalizeModelEntry(entry);
        if (!normalized) return;
        modelOptions.push(
          '<option value="' + escapeHtml(normalized.target) + '">' + escapeHtml(normalized.label) + '</option>'
        );
      });

      modelSelect.innerHTML = modelOptions.join('');
      modelSelect.disabled = modelSelect.options.length <= 1;

      if (modelSelect.disabled) {
        modelSelect.innerHTML = '<option value="">No models found yet for this series…</option>';
      }

      viewBtn.disabled = true;
      viewBtn.setAttribute('data-disabled-reason', 'Choose your exact model to view the collection.');
    });

    modelSelect.addEventListener('change', function () {
      var target = modelSelect.value;

      if (!target) {
        viewBtn.disabled = true;
        viewBtn.removeAttribute('data-collection-url');
        viewBtn.removeAttribute('data-collection-handle');
        viewBtn.setAttribute('data-disabled-reason', 'Choose your exact model to view the collection.');
        return;
      }

      viewBtn.disabled = false;
      viewBtn.setAttribute('data-collection-url', target);
      viewBtn.setAttribute('data-collection-handle', target.replace(/^\/collections\//, ''));
      viewBtn.removeAttribute('data-disabled-reason');
    });

    viewBtn.addEventListener('click', function () {
      if (viewBtn.disabled) return;

      var url = viewBtn.getAttribute('data-collection-url');
      if (!url) return;

      window.location.href = url;
    });

    window.addEventListener('pageshow', function (event) {
      var fromCache = false;

      if (event && event.persisted) {
        fromCache = true;
      } else {
        try {
          var navEntries = window.performance && performance.getEntriesByType
            ? performance.getEntriesByType('navigation')
            : [];
          fromCache = !!(navEntries && navEntries[0] && navEntries[0].type === 'back_forward');
        } catch (e) {}
      }

      if (fromCache && brandSelect.value && seriesSelect.disabled) {
        brandSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initJMCompatNav);
  } else {
    initJMCompatNav();
  }
})();
